<template>
  <el-form
    :model="withdrawData"
    :rules="rules"
    ref="userForm"
    label-width="15%"
    class="demo-userForm"
    style="margin-top: 30px;"
  >
    <el-form-item :label="generateCustomizeString('withdrawAmount')">
      <span>NZD ${{ withdrawData.amount | formatAmount }}</span>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('withdrawCurrency')">
      <span>{{ withdrawData.currency_type }}</span>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('withdrawChannel')">
      <span>{{ withdrawData.channel_name }}</span>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('name')">
      <span>{{ withdrawData.account_name }}</span>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('accountNumber')">
      <span>{{ withdrawData.account }}</span>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('submitTime')">
      <span>{{ withdrawData.created_at }}</span>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('allDocs')">
      <el-row>
        <el-col :span="15">
          <div v-for="item in withdrawData.images" :key="item.id">
            <img :src="item.image_url" alt style="width:70%;">
          </div>
        </el-col>
        <!-- <el-col :span="7" style="border: 2px solid black; padding: 10px;">
          <h4>转款资料文件说明</h4>
          <span>CNY:</span>
          <h5>请上传身份证文件(根据币种上传的信息不一样), 中华人民共和国居民身份证, 或中华人民共和国因私护照</h5>
          <span>NZD:</span>
          <h5>新西兰护照 或者驾照 或者 18+卡, 并有效期6个月内的水电账单</h5>
          <span>AUD:</span>
          <h5>澳洲护照 或者 驾照 或者 18+卡, 并有效期6个月内的水电账单</h5>
        </el-col> -->
      </el-row>
    <!-- </el-form-item>
    <el-form-item :label="generateCustomizeString('evidenceOfPayment')"> -->
      <!-- <el-row>
        <el-col :span="15">
          <div v-for="(item, index) in imgList" :key="index">
            <img :src="item" alt style="width:70%;">
          </div>
        </el-col>
      </el-row> -->
      <el-upload
        action="https://upload-z2.qiniup.com"
        :limit="1"
        :on-success="handleUploadSuccess"
        :on-error="handleError"
        :before-upload="beforeUpload"
        :data="qiniuData"
      >
        <el-button size="small" type="primary">{{ generateCustomizeString('clickToUpload') }}</el-button>
        <div class="el-upload__tip" slot="tip">{{generateCustomizeString('fileLimit')}}</div>
      </el-upload>
    </el-form-item>
    <el-form-item>
      <el-button type="warning" v-if="withdrawData.currency_type !== 'NZD'" @click="emailconfirm = true">联系IEMONEY(快速汇款)</el-button>
    </el-form-item>
    <el-form-item>
      <h5>{{ withdrawData.shop.account_manager}} {{ withdrawData.shop.account_manager_mobile_phone }}</h5>
      <span>{{ generateCustomizeString('withdrawNotice1') }}</span><br>
      <span>{{ generateCustomizeString('withdrawNotice2') }}</span>
    </el-form-item>
    <el-button
      type="primary"
      v-if="withdrawData.status_name === '申请提现'"
      @click="dialogVisible = true"
    >
    {{ generateCustomizeString('markAsPaid') }}
    </el-button>
    <el-button type="primary" v-if="withdrawData.status_name === '已转账'" disabled>{{ generateCustomizeString('finalizeWithdraw') }}</el-button>

    <!-- 弹出确认框 -->
    <el-dialog title="Warning" :visible.sync="dialogVisible" width="30%" center>
      <h3>{{ generateCustomizeString('confirmFinalizeWithdraw') }}</h3>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ generateCustomizeString('cancel') }}</el-button>
        <el-button type="primary" @click="agreeWithdraw()">{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <!-- 弹出email发送确认框 -->
    <el-dialog :title="generateCustomizeString('confirm')" :visible.sync="emailconfirm" width="30%" center>
      <h3>{{ generateCustomizeString('withdrawNotice3') }} </h3>
      <span slot="footer" class="dialog-footer">
        <el-button @click="emailconfirm = false">{{ generateCustomizeString('cancel') }}</el-button>
        <el-button type="primary" @click="emailIEMONEY">{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>
  </el-form>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import dayjs from 'dayjs'

export default {
  name: 'WithdrawDetail',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      withdrawData: {
        shop: {
          account_manager: ''
        }
      },
      dialogVisible: false,
      emailconfirm: false,
      qiniuData: {
        token: ''
      },
      imgKey: [],
      imgList: []
    }
  },
  computed: {},
  methods: {
    generateCustomizeString,
    fetchWithdrawDetail() {
      request({
        url: 'agent/application/' + this.$route.params.applicationId,
        method: 'get'
      }).then(res => {
        if (res.status === 0) {
          this.withdrawData = res.data
          this.withdrawData.created_at = this.withdrawData.created_at.replace(/-/g, '/')
          this.withdrawData.created_at = dayjs(new Date(this.withdrawData.created_at + ' UTC')).format('YYYY-M-D HH:mm:ss')
          console.log(this.withdrawData)

          // images
          this.imgKey = []
          this.imgList = []
          const images = res.data.images
          for (let i = 0; i < images.length; i++) {
            this.imgKey.push(images[i].qiniu_res_key)
            this.imgList.push(images[i].image_url)
          }
          console.log(this.imgKey)
        }
      })
    },
    agreeWithdraw() {
      this.dialogVisible = false
      request({
        url: 'agent/application',
        method: 'patch',
        params: {
          wallet_withdrawal_applications_id: this.$route.params.applicationId
        }
      }).then(res => {
        if (res.status === 0) {
          this.$message({
            message: '转账已完成, 具体到账时间以实际为准,平台无法确认, 已经发送通知短信给客户',
            type: 'success'
          })
        }
      })
    },
    emailIEMONEY() {
      this.$message({
        message: '已将该代理商的提现需求通过EMAIL发送给IEMONEY, 请您稍等片刻, IEMONEY的客服人员将尽快联系您',
        type: 'success'
      })
      request({
        url: 'agent/application/' + this.$route.params.applicationId + '/mail',
        method: 'get'
      }).then(res => {
        if (res.status === 0) {
          this.$message({
            message: '邮件发送成功！',
            type: 'success'
          })
        }
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
        this.emailconfirm = false
      })
    },
    fetchUploadToken() {
      request({
        url: '/upload-private-token',
        method: 'get'
      })
        .then(res => {
          this.qiniuData.token = res.data['token']
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleUploadSuccess(res, file) {
      this.imgKey.push(res.key)
      console.log(this.imgKey)
      request({
        url: '/agent/application/images',
        method: 'patch',
        params: {
          upload_image_keys: this.imgKey,
          wallet_withdrawal_applications_id: this.$route.params.applicationId
        }
      }).then(res => {
        if (res.status === 0) {
          this.$message({
            message: '转账凭证上传成功!',
            type: 'success'
          })
          this.fetchWithdrawDetail()
        }
      }).catch(error => {
        console.warn(error)
      })
    },
    handleError(res) {
      console.log(res)
    },
    beforeUpload(file) {
      // 在图片提交前进行验证
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG && !isPNG) {
        this.$message.error('转账凭证只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('转账凭证大小不能超过 2MB!')
      }
      return (isJPG || isPNG) && isLt2M
    }
  },
  filters: {
    formatAmount: function(value) {
      if (!value) return
      return (value / 100).toFixed(2)
    }
  },
  created() {
    this.fetchUploadToken()
    this.fetchWithdrawDetail()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
span {
  color: #0999d5;
}
.el-button {
  margin-left: 3rem;
  margin-bottom: 3rem;
}
h5 {
  margin: 0;
}
</style>
